'use strict';

var is = require('bpmn-js/lib/util/ModelUtil').is,
    isAny = require('bpmn-js/lib/features/modeling/util/ModelingUtil').isAny,
    getBusinessObject = require('bpmn-js/lib/util/ModelUtil').getBusinessObject,
    domQuery = require('min-dom').query,
    cmdHelper = require('../../../helper/CmdHelper'),
    elementHelper = require('../../../helper/ElementHelper'),
    eventDefinitionHelper = require('../../../helper/EventDefinitionHelper'),
    script = require('./implementation/Script')('language', 'body', true),
	getExtensionElements = require('../../../helper/ExtensionElementsHelper').getExtensionElements;


module.exports = function(group, element, bpmnFactory, translate) {
  var bo = getBusinessObject(element);

  if (!bo) {
    return;
  }

	
	  
  var conditionalEventDefinition = eventDefinitionHelper.getConditionalEventDefinition(element);

  if (!(is(element, 'bpmn:SequenceFlow') && isConditionalSource(element.source))
    && !conditionalEventDefinition) {
    return;
  }
  
  
  if (is(element, 'bpmn:SequenceFlow') && element.source && element.source.type != "bpmn:ExclusiveGateway"){
	  return;
  }
  
  
	 var conditionExpression = conditionalEventDefinition
			? conditionalEventDefinition.condition
			: bo.conditionExpression;
	
	var conditionType = "";
	var expression = "";
	if (conditionExpression) {
        var conditionLanguage = conditionExpression.language;
        if (typeof conditionLanguage !== 'undefined') {
          conditionType = 'script';
		  expression = conditionExpression.get('body');
        } else {
          conditionType = 'expression';
          expression = conditionExpression.get('body');
        }
      }
	  
	  
	  let attributeValue = "";
	  let attributeName = "";
	  if (conditionType == 'script'){
		
		if (expression != undefined && expression != ""){
			let tmp = expression.replaceAll('execution.getVariable', '');
			tmp = tmp.replaceAll('("','');
			tmp = tmp.replaceAll('")','');
			// custom_attribute_value = tmp.split('"')[1];
			
			if (tmp.includes('==')){
				attributeName = tmp.split('==')[0];
				attributeValue = tmp.split('==')[1];
			}
			
			if (tmp.includes('!=')){
				attributeName = tmp.split('!=')[0];
				attributeValue = tmp.split('!=')[1];
			}
			
			if (tmp.includes('>')){
				attributeName = tmp.split('>')[0];
				attributeValue = tmp.split('>')[1];
			}
			if (tmp.includes('<')){
				attributeName = tmp.split('<')[0];
				attributeValue = tmp.split('<')[1];
			}
			if (tmp.includes('>=')){
				attributeName = tmp.split('>=')[0];
				attributeValue = tmp.split('>=')[1];
			}
			if (tmp.includes('<=')){
				attributeName = tmp.split('<=')[0];
				attributeValue = tmp.split('<=')[1];
			}
		}
		
	}
	
	
	const taskTypesList = [];
	let taskTypes_options = ""; 
	var elementParent = element.businessObject.sourceRef;

	var found = false;
	while (!found){


		console.log('----------------------------ELEMENT PARENT----------------------------');
		console.log(elementParent);
		console.log('----------------------------ELEMENT PARENT 	TYPE----------------------------');
		console.log(elementParent.$type);
		
		if (elementParent.$type == "bpmn:StartEvent"){
			found = true;
			break;
		}
		if (elementParent.$type == "bpmn:SubProcess"){

			console.log('----------------------------ELEMENT PARENT SUB PROCESS----------------------------');
			console.log(elementParent.name);
			console.log(elementParent);
			var taskListSubProcess = [];
			const taskSubProcess =  elementParent.flowElements.filter(x => x.$type === 'bpmn:UserTask');
			if(taskSubProcess.length >0){
				
				taskSubProcess.forEach(function(element, index){ 	
					if (element.name){
						
						taskTypesList[element.id] = element.name;
					}
					else{
						taskTypesList[element.id] = element.id;
					} })

			}
			//console.log(taskSubProcess);

		}
		//MAURO
		if (elementParent.$type == "bpmn:UserTask" ){
			if (elementParent.name){
				taskTypesList[elementParent.id] = elementParent.name;
			}
			else{
				taskTypesList[elementParent.id] = elementParent.id;
			}
		}
		//MAURO
		if ( elementParent.$type == 'bpmn:ServiceTask'){
			if (elementParent.name){
				taskTypesList[elementParent.id] = elementParent.name;
			}
			else{
				taskTypesList[elementParent.id] = elementParent.id;
			}
		}
				//MAURO
		if ( elementParent.$type == 'bpmn:ReceiveTask'){
			if (elementParent.name){
				taskTypesList[elementParent.id] = elementParent.name;
			}
			else{
				taskTypesList[elementParent.id] = elementParent.id;
			}
		}
		
		//task parent inner sub process
		const subProcessesElementsParent=  elementParent.$parent.flowElements.filter(x => x.$type === 'bpmn:SubProcess');
		
		if(subProcessesElementsParent.length >0){
				if(subProcessesElementsParent[0].flowElements.length > 0){
			
			const taskSubProcessesElementsParent=  subProcessesElementsParent[0].flowElements.filter(x => x.$type === 'bpmn:UserTask');
			taskSubProcessesElementsParent.forEach(function(element, index){ 	
				if (element.name){
					
					taskTypesList[element.id] = element.name;
				}
				else{
					taskTypesList[element.id] = element.id;
				} })
				
			}
		}
	
			//task parent 

			const taskElementsParent=  elementParent.$parent.flowElements.filter(x => x.$type === 'bpmn:UserTask');
			if(taskElementsParent.length >0){

				taskElementsParent.forEach(function(element, index){ 	
					if (element.name){
	
					taskTypesList[element.id] = element.name;
				}
				else{
					taskTypesList[element.id] = element.id;
				} })


			}

		if (elementParent.incoming){
			elementParent = elementParent.incoming[0];
		}
		else if (elementParent.sourceRef){
			elementParent = elementParent.sourceRef;
		}
		else{
			found = true;
		}
	}

	var attributes_options = "";
	if (attributeName != ""){
		
		for (var keyItem in taskTypesList){
			if (attributeName.includes(keyItem)){
				attributes_options = '<option value="' + attributeName + '">' + attributeName + '</option>';
				taskTypes_options += '<option selected value="' + keyItem + '">' + translate(taskTypesList[keyItem]) + '</option>';
			}
			else{
				taskTypes_options += '<option value="' + keyItem + '">' + translate(taskTypesList[keyItem]) + '</option>';
			}
			
		}
		if (attributes_options == ""){
			attributes_options = '<option value="' + attributeName + '">' + attributeName + '</option>';
		}
	}
	else{
		for (var keyItem in taskTypesList){
			taskTypes_options += '<option value="' + keyItem + '">' + translate(taskTypesList[keyItem]) + '</option>';
		}
		
	}
	
  group.entries.push({
    id: 'condition',
    label: translate('Condition'),
    html: '<div class="bpp-row">' +
              '<label for="cam-condition-type">'+translate('Condition Type')+'</label>' +
              '<div class="bpp-field-wrapper">' +
                '<select id="cam-condition-type" name="conditionType" data-value>' +
				// '<option value="" selected></option>' +
                // '<option value="expression">'+translate('Expression')+'</option>' +
                  '<option value="script" selected>'+translate('Script')+'</option>' +
                  
                '</select>' +
              '</div>' +
            '</div>' +
			
			
			
			// task type condition
            '<div class="bpp-row">' +
              '<label for="custom_task_type" data-show="isScript">'+translate('Tasks')+'</label>' +
              '<div class="bpp-field-wrapper" data-show="isScript">' +
                '<select id="custom_task_type"  name="custom_task_type" data-value/>' +
				'<option value=""></option>' +
                 taskTypes_options +
				 '</select>' +
              '</div>' +
            '</div>' + 
			
			// task type attributes
            '<div class="bpp-row">' +
              '<label for="custom_task_type_attributes" data-show="isScript">'+translate('Task Type Attribute')+'</label>' +
              '<div class="bpp-field-wrapper" data-show="isScript">' +
                '<select id="custom_task_type_attributes"  name="custom_task_type_attributes" data-value/>' +
				'<option value="" selected></option>' +
				attributes_options +
				 '</select>' +
              '</div>' +
            '</div>' + 
			
			// task type condition
            '<div class="bpp-row">' +
              '<label for="custom_task_type_condition" data-show="isScript">'+translate('Condition')+'</label>' +
              '<div class="bpp-field-wrapper" data-show="isScript">' +
                '<select id="custom_task_type_condition"  name="custom_task_type_condition" data-value/>' +
				'<option value="" selected></option>' +
                 '<option value="==">' + translate("=") + '</option>' +
                 '<option value="!=">' + translate("≠") + '</option>' +
                 '<option value=">">' + translate(">") + '</option>' +
                 '<option value="<">' + translate("<") + '</option>' +
				 '<option value=">=">' + translate(">=") + '</option>' +
				 '<option value="<=">' + translate("<=") + '</option>' +

				 '</select>' +
              '</div>' +
            '</div>' + 
			
			// attribute Type
            '<div id="wrapper_custom_task_type_attribute_value_select" class="bpp-row hidden" style= "margin-bottom:1em">' +
              '<label for="custom_task_type_attribute_value" data-show="isScript">'+translate('Attribute Type')+'</label>' +
              '<div class="bpp-field-wrapper" data-show="isScript">' +
				'<select  id="custom_task_type_attribute_value_select"  name="custom_task_type_attribute_value_select" data-value/>' +
				
				'</select>' +

              '</div>' +
            '</div>' +
			// attribute value
            '<div id="wrapper_custom_task_type_attribute_value" class="bpp-row">' +
              '<label for="custom_task_type_attribute_value" data-show="isScript">'+translate('Attribute Value')+'</label>' +
              '<div class="bpp-field-wrapper" data-show="isScript">' +
				'<input id="custom_task_type_attribute_value" type="text" name="custom_task_type_attribute_value" />' +

              '</div>' +
            '</div>' +
		
	
            // expression
            '<div class="bpp-row">' +
              '<label for="cam-condition" data-show="isExpression">'+translate('Expression')+'</label>' +
              '<div class="bpp-field-wrapper" data-show="isExpression">' +
                '<input id="cam-condition" type="text" name="condition" />' +
                '<button class="clear" data-action="clear" data-show="canClear">' +
                  '<span>X</span>' +
                '</button>' +
              '</div>' +
              '<div data-show="isScript">' +
                script.template +
              '</div>' +
            '</div>',

    get: function(element, propertyName) {
      var conditionalEventDefinition = eventDefinitionHelper.getConditionalEventDefinition(element);
	  	
      var conditionExpression = conditionalEventDefinition
        ? conditionalEventDefinition.condition
        : bo.conditionExpression;

      var values = {},
          conditionType = '';
	
	
	
	
      if (conditionExpression) {
        var conditionLanguage = conditionExpression.language;
        if (typeof conditionLanguage !== 'undefined') {
          conditionType = 'script';
          values = script.get(element, conditionExpression);
        } else {
          conditionType = 'expression';
          values.condition = conditionExpression.get('body');
        }
      }
	
	  if (conditionType == 'script'){
		 // console.log('GET');
		   // console.log(values);
		  
		// const expression = values.condition;
		const expression = values.scriptValue;
		let custom_attribute_value = "";
		let custom_attribute_name = "";
		let custom_condition = "";
		if (expression != undefined && expression != ""){
			let tmp = expression.replaceAll('execution.getVariable', '');
			tmp = tmp.replaceAll('("','');
			tmp = tmp.replaceAll('")','');
			tmp = tmp.replaceAll(/"/g,'');
			// custom_attribute_value = tmp.split('"')[1];
			//console.log('GET')
			//console.log(tmp)
			
			if (tmp.includes('==')){
				custom_attribute_name = tmp.split('==')[0];
				custom_attribute_value = tmp.split('==')[1];
				custom_condition = "==";
			}
			
			if (tmp.includes('!=')){
				custom_attribute_name = tmp.split('!=')[0];
				custom_attribute_value = tmp.split('!=')[1];
				custom_condition = "!=";
			}
			
			if (tmp.includes('>')){
				custom_attribute_name = tmp.split('>')[0];
				custom_attribute_value = tmp.split('>')[1];
				custom_condition = ">";
			}
			if (tmp.includes('<')){
				custom_attribute_name = tmp.split('<')[0];
				custom_attribute_value = tmp.split('<')[1];
				custom_condition = "<";
			}
			if (tmp.includes('>=')){
				custom_attribute_name = tmp.split('>=')[0];
				custom_attribute_value = tmp.split('>=')[1];
				custom_condition = ">=";
			}
			if (tmp.includes('<=')){
				custom_attribute_name = tmp.split('<=')[0];
				custom_attribute_value = tmp.split('<=')[1];
				custom_condition = "<=";
			}
	  
			if (custom_attribute_value != ""){
				values.custom_task_type_attribute_value = custom_attribute_value;
				// if (document.getElementById('custom_task_type_attribute_value').value != "" && document.getElementById('custom_task_type_attribute_value').value != custom_task_type){
					// values.custom_task_type_attribute_value = document.getElementById('custom_task_type_attribute_value').value;
				// }
			}
			else{
				values.custom_task_type_attribute_value = document.getElementById('custom_task_type_attribute_value').value;
			}															 
			if (custom_attribute_name != ""){
				values.custom_task_type_attributes = custom_attribute_name;
				
			}
			else{
				values.custom_task_type_attributes = document.getElementById('custom_task_type_attributes').options[document.getElementById('custom_task_type_attributes').selectedIndex].value;
			}
			
			if (custom_condition != ""){
				values.custom_task_type_condition = custom_condition;
				
			}
			else{
				values.custom_task_type_condition = document.getElementById('custom_task_type_condition').options[document.getElementById('custom_task_type_condition').selectedIndex].value;
			}
	
		}
		
	}
	
		values.conditionType = "script";
		
		
		
      return values;

    },

    set: function(element, values, containerElement) {
		//console.log('SET');
		//console.log(values);
      var conditionType = values.conditionType;
      var commands = [];

      var conditionProps = {
        body: undefined
      };

      if (conditionType === 'script') {
        conditionProps = script.set(element, values, containerElement);
      // } else {
		  
		  
        var condition = values.condition;
		conditionProps.body = condition;
		//set empty value if select value != none
		var type_attr = 		values.custom_task_type_attributes;
	    var type_conditions =  	values.custom_task_type_condition;
		var type_value_input = 	values.custom_task_type_attribute_value;
		var type_value_select = values.custom_task_type_attribute_value_select


		if (type_attr && type_conditions && type_value_input != "" && type_value_select == 'none'){
				conditionProps.body = 'execution.getVariable("' + type_attr + '")' + type_conditions + '"' + type_value_input + '"';
		}
		if (type_attr && type_conditions && type_value_select != 'none'){
				var valTaskType = document.getElementById('custom_task_type_attributes').value; 
				if(valTaskType.startsWith("attribute_")){
					conditionProps.body = 'execution.getVariable("' + type_attr + '")' + type_conditions + '"' + type_value_select + '"';

				}else{
					conditionProps.body = 'execution.getVariable("' + type_attr + '")' + type_conditions + 'execution.getVariable("' + type_value_select + '")';

				}
		}

		
		if (values.custom_task_type_attribute_value == "" && type_value_select == 'none' ){
			conditionProps.body = "";
		}
		
		
	
		
      // }

	}

      var conditionOrConditionExpression;

      if (conditionType) {
        conditionOrConditionExpression = elementHelper.createElement(
          'bpmn:FormalExpression',
          conditionProps,
          conditionalEventDefinition || bo,
          bpmnFactory
        );

        var source = element.source;

        // if default-flow, remove default-property from source
        if (source && source.businessObject.default === bo) {
          commands.push(cmdHelper.updateProperties(source, { 'default': undefined }));
        }
      }

      var update = conditionalEventDefinition
        ? { condition: conditionOrConditionExpression }
        : { conditionExpression: conditionOrConditionExpression };

      commands.push(cmdHelper.updateBusinessObject(element, conditionalEventDefinition || bo, update));

      return commands;
    },

    validate: function(element, values) {
      var validationResult = {};

      if (!values.condition && values.conditionType === 'expression') {
        validationResult.condition = 'Must provide a value';
      }
      else if (values.conditionType === 'script') {
        validationResult = script.validate(element, values);
      }

      return validationResult;
    },

    isExpression: function(element, inputNode) {
      var conditionType = domQuery('select[name=conditionType]', inputNode);
      if (conditionType.selectedIndex >= 0) {
        return conditionType.options[conditionType.selectedIndex].value === 'expression';
      }
    },

    isScript: function(element, inputNode) {
      var conditionType = domQuery('select[name=conditionType]', inputNode);
      if (conditionType.selectedIndex >= 0) {
        return conditionType.options[conditionType.selectedIndex].value === 'script';
      }
    },

    clear: function(element, inputNode) {
      // clear text input
      domQuery('input[name=condition]', inputNode).value='';

      return true;
    },

    canClear: function(element, inputNode) {
      var input = domQuery('input[name=condition]', inputNode);

      return input.value !== '';
    },

    script : script,

    cssClasses: [ 'bpp-textfield' ]
  });
};


// utilities //////////////////////////

var CONDITIONAL_SOURCES = [
  'bpmn:Activity',
  'bpmn:ExclusiveGateway',
  'bpmn:InclusiveGateway',
  'bpmn:ComplexGateway'
];

function isConditionalSource(element) {
  return isAny(element, CONDITIONAL_SOURCES);
}
